import React, { useState, useEffect, useRef } from "react";
import "./Sidebar.css";
import { IoIosArrowForward, IoIosArrowDown } from "react-icons/io";
import { IoCloseOutline } from "react-icons/io5";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import API_URL from "../../src/Config";
import { FaSearch } from "react-icons/fa";

import {
  LuAward,
  LuBadgeCheck,
  LuBookOpen,
  LuBookOpenCheck,
  LuBoxes,
  LuBuilding2,
  LuCalendarCheck,
  LuCalendarClock,
  LuCalendarRange,
  LuCalendarSync,
  LuChartColumn,
  LuChartNoAxesColumn,
  LuChartNoAxesCombined,
  LuChartPie,
  LuClipboardCheck,
  LuClipboardList,
  LuCog,
  LuContact,
  LuContactRound,
  LuCpu,
  LuCylinder,
  LuDot,
  LuFactory,
  LuFileChartColumn,
  LuFileClock,
  LuFileHeart,
  LuFilePlus2,
  LuFileSearch,
  LuFileSpreadsheet,
  LuFileText,
  LuFiles,
  LuFlaskConical,
  LuFolderKanban,
  LuFolderOpen,
  LuGauge,
  LuGitBranch,
  LuGraduationCap,
  LuHandshake,
  LuHardHat,
  LuHistory,
  LuIdCard,
  LuLayers3,
  LuLayoutDashboard,
  LuLibrary,
  LuListOrdered,
  LuListTree,
  LuMail,
  LuMailCheck,
  LuNetwork,
  LuPackageCheck,
  LuPackageMinus,
  LuPackagePlus,
  LuPackageSearch,
  LuPackageX,
  LuPresentation,
  LuRadioTower,
  LuReceipt,
  LuScanEye,
  LuSettings2,
  LuShieldCheck,
  LuShieldPlus,
  LuShip,
  LuShoppingCart,
  LuSignature,
  LuSlidersHorizontal,
  LuUserRoundPlus,
  LuUsers,
  LuUsersRound,
  LuWallet,
  LuWorkflow,
  LuWrench,
} from "react-icons/lu";
import { FiLogOut } from "react-icons/fi";

console.log(" axiosVERSION", axios.VERSION);

const iconMap = {
  RxDashboard: LuLayoutDashboard,
  VscGraph: LuChartColumn,
  MdApproval: LuBadgeCheck,
  PiNewspaperClipping: LuFileText,
  LiaDumpsterFireSolid: LuShieldPlus,
  RiCalendarScheduleLine: LuCalendarClock,
  LiaFileInvoiceSolid: LuFileText,
  TbChartPie: LuChartPie,
  LuHistory,
  FiShoppingCart: LuShoppingCart,
  LuLibrary,
  PiUserListBold: LuUsersRound,
  TbBuildingStore: LuFactory,
  RxCube: LuBoxes,
  TbSettingsStar: LuSettings2,
  IoSettingsOutline: LuCog,
  LuUsers,
  AiOutlineAudit: LuFileSearch,
  PiDotOutlineFill: LuDot,
  TbReportSearch: LuFileChartColumn,
  FaExchangeAlt: LuPackageSearch,
  LuCalendarDays: LuCalendarCheck,
  LuFileSpreadsheet,
  IoThermometerOutline: LuGauge,
  RiSuitcase2Line: LuRadioTower,
  BiGasPump: LuCylinder,
  FiBarChart2: LuChartColumn,
  FiSettings: LuCog,
  FiFileText: LuFileText,
  FiUsers: LuUsersRound,
  MdPropaneTank: LuCylinder,
  FaUserShield: LuBuilding2,
  MdStorage: LuNetwork,
  TbReportMoney: LuReceipt,
  FcInspection: LuClipboardCheck,
  dot: LuDot,
};

const iconNameRules = [
  { keywords: ["monthly report logs"], icon: LuFileClock },
  { keywords: ["sender emails"], icon: LuMailCheck },
  { keywords: ["email templates"], icon: LuMail },
  { keywords: ["mat code levels"], icon: LuListOrdered },
  { keywords: ["mat codes"], icon: LuListTree },
  { keywords: ["calibration gas types"], icon: LuFlaskConical },
  { keywords: ["gas detector types"], icon: LuRadioTower },
  { keywords: ["frequency configuration"], icon: LuCalendarSync },
  { keywords: ["sub type variants"], icon: LuLayers3 },
  { keywords: ["equipment sub types", "equipment sub type"], icon: LuWorkflow },
  { keywords: ["equipment types", "equipment type"], icon: LuCpu },
  { keywords: ["sub departments", "sub department"], icon: LuGitBranch },
  { keywords: ["departments", "department"], icon: LuNetwork },
  { keywords: ["document library"], icon: LuFolderOpen },
  { keywords: ["mass schedule generator"], icon: LuCalendarRange },
  { keywords: ["designations", "designation"], icon: LuIdCard },
  { keywords: ["contractor companies", "contractor company"], icon: LuBuilding2 },
  { keywords: ["equipments", "equipment"], icon: LuCog },
  { keywords: ["system users"], icon: LuUsers },
  { keywords: ["expense reports"], icon: LuChartNoAxesCombined },
  { keywords: ["advances", "advance"], icon: LuWallet },
  { keywords: ["expenses", "expense"], icon: LuReceipt },
  { keywords: ["statutory audits", "statutory audit"], icon: LuFileSearch },
  { keywords: ["statutory approvals", "statutory approval"], icon: LuBadgeCheck },
  { keywords: ["standards", "standard"], icon: LuBookOpenCheck },
  { keywords: ["catalogue", "catalog"], icon: LuLibrary },
  { keywords: ["training sessions", "training session"], icon: LuPresentation },
  { keywords: ["due & overdue", "due and overdue"], icon: LuCalendarClock },
  { keywords: ["training dashboard"], icon: LuGraduationCap },
  { keywords: ["training certificates", "training certificate"], icon: LuAward },
  { keywords: ["medical reports", "medical report"], icon: LuFileHeart },
  { keywords: ["manpower report"], icon: LuChartNoAxesColumn },
  { keywords: ["actual manpowers", "actual manpower"], icon: LuUsersRound },
  { keywords: ["manpower requirements", "manpower requirement"], icon: LuUserRoundPlus },
  { keywords: ["monthly compliances", "monthly compliance"], icon: LuClipboardCheck },
  { keywords: ["boqs", "boq"], icon: LuFileSpreadsheet },
  { keywords: ["amc projects", "amc project"], icon: LuFolderKanban },
  { keywords: ["amc customers", "amc customer"], icon: LuHandshake },
  { keywords: ["barrel ledger"], icon: LuBookOpen },
  { keywords: ["purchase indents", "purchase indent"], icon: LuFileText },
  { keywords: ["product inward"], icon: LuPackagePlus },
  { keywords: ["barrel customers", "barrel customer"], icon: LuUsersRound },
  { keywords: ["barrel products", "barrel product"], icon: LuCylinder },
  { keywords: ["vendors", "vendor"], icon: LuContactRound },
  { keywords: ["purchase orders", "purchase order"], icon: LuClipboardList },
  { keywords: ["approved pr for purchase"], icon: LuBadgeCheck },
  { keywords: ["purchase request report"], icon: LuFileChartColumn },
  { keywords: ["new purchase request"], icon: LuShoppingCart },
  { keywords: ["gas cylinders", "gas cylinder"], icon: LuCylinder },
  { keywords: ["returnable items", "returnable"], icon: LuPackageSearch },
  { keywords: ["amc consumptions", "amc consumption"], icon: LuChartPie },
  { keywords: ["material issue"], icon: LuPackageMinus },
  { keywords: ["rejected material"], icon: LuPackageX },
  { keywords: ["incoming material inspection"], icon: LuPackageCheck },
  { keywords: ["material inward"], icon: LuPackagePlus },
  { keywords: ["inventory"], icon: LuBoxes },
  { keywords: ["hse policy"], icon: LuShieldCheck },
  { keywords: ["safety meetings", "safety meeting"], icon: LuUsersRound },
  { keywords: ["safety observations", "safety observation"], icon: LuScanEye },
  { keywords: ["safety induction"], icon: LuShieldPlus },
  { keywords: ["manual work permit"], icon: LuSignature },
  { keywords: ["excavation department review"], icon: LuHardHat },
  { keywords: ["work permit inspection (o&m head)", "work permit inspection o&m head"], icon: LuClipboardCheck },
  { keywords: ["work permit inspection (f & s)", "work permit inspection f & s"], icon: LuShieldCheck },
  { keywords: ["all permit requests"], icon: LuFiles },
  { keywords: ["permit requests (requester)", "permit requests requester", "permit requests"], icon: LuFilePlus2 },
  { keywords: ["qc inspections", "qc inspection"], icon: LuClipboardCheck },
  { keywords: ["monthly inventory reports", "monthly inventory report"], icon: LuFileSpreadsheet },
  { keywords: ["voyages", "voyage"], icon: LuShip },
  { keywords: ["daily work progress", "work progress"], icon: LuClipboardList },
  { keywords: ["gas detector calibrations", "gas detector calibration"], icon: LuSlidersHorizontal },
  { keywords: ["gas detectors", "gas detector"], icon: LuRadioTower },
  { keywords: ["amc configuration"], icon: LuSettings2 },
  { keywords: ["amc schedules", "amc schedule"], icon: LuCalendarCheck },
  { keywords: ["history card", "history"], icon: LuHistory },
  { keywords: ["breakdowns", "breakdown"], icon: LuWrench },
  { keywords: ["preventive schedules", "preventive schedule"], icon: LuCalendarClock },
  { keywords: ["qc reports", "qc report"], icon: LuFileChartColumn },
  { keywords: ["general report"], icon: LuChartColumn },
  { keywords: ["calibration report"], icon: LuGauge },
  { keywords: ["dashboard"], icon: LuLayoutDashboard },
  { keywords: ["customers", "customer"], icon: LuContact },
  { keywords: ["projects", "project"], icon: LuFolderKanban },
  { keywords: ["plants", "plant"], icon: LuFactory },
  { keywords: ["reports", "report"], icon: LuFileChartColumn },
];

const getIconByName = (value = "") => {
  const normalizedValue = value.toLowerCase();

  const matchedRule = iconNameRules.find((rule) =>
    rule.keywords.some((keyword) => normalizedValue.includes(keyword))
  );

  return matchedRule?.icon;
};

const resolveIconComponent = (iconName, item = {}) => {
  const itemNameIcon = getIconByName(item.name);
  const categoryIcon = getIconByName(item.category);

  if (itemNameIcon) {
    return itemNameIcon;
  }

  if (iconMap[iconName]) {
    return iconMap[iconName];
  }

  return categoryIcon || LuDot;
};

const getOrderValue = (value) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : Number.MAX_SAFE_INTEGER;
};

const sortByMenuOrder = (left, right) => {
  const leftOrder = getOrderValue(left.serial_no ?? left.category_order);
  const rightOrder = getOrderValue(right.serial_no ?? right.category_order);

  if (leftOrder !== rightOrder) {
    return leftOrder - rightOrder;
  }

  return (left.name || left.category || "").localeCompare(
    right.name || right.category || ""
  );
};

const normalizeMenuItems = (items = []) =>
  [...items]
    .map((item) => ({
      ...item,
      sub_menu: normalizeMenuItems(item.sub_menu || []),
    }))
    .sort(sortByMenuOrder);

const normalizeMenuData = (data) => {
  let menuData = data;

  if (typeof menuData === "string") {
    try {
      menuData = JSON.parse(menuData);
    } catch (error) {
      console.error("Invalid sidebar menu response:", error.message);
      menuData = [];
    }
  }

  if (!Array.isArray(menuData)) {
    menuData =
      menuData?.data ||
      menuData?.menus ||
      menuData?.menu_items ||
      menuData?.items ||
      menuData;
  }

  const categories = Array.isArray(menuData)
    ? menuData.map((category, index) => [String(index), category])
    : Object.entries(menuData || {});

  return categories
    .map(([categoryKey, category]) => {
      const categoryData = Array.isArray(category)
        ? {
            category: categoryKey,
            menu_items: category,
          }
        : {
            ...category,
            category: category?.category || categoryKey,
          };

      return {
        ...categoryData,
        category_order: categoryData.category_order ?? categoryKey,
        menu_items: normalizeMenuItems(categoryData.menu_items || []),
      };
    })
    .sort((left, right) => {
      const leftOrder = getOrderValue(left.category_order);
      const rightOrder = getOrderValue(right.category_order);

      if (leftOrder !== rightOrder) {
        return leftOrder - rightOrder;
      }

      return String(left.category || "").localeCompare(
        String(right.category || "")
      );
    });
};

const collectRoutes = (items = [], routes = []) => {
  items.forEach((item) => {
    if (item.route) {
      routes.push(item.route);
    }

    if (Array.isArray(item.sub_menu) && item.sub_menu.length > 0) {
      collectRoutes(item.sub_menu, routes);
    }
  });

  return routes;
};

function Sidebar({ onSidebarToggle }) {
  const location = useLocation();
  const navigate = useNavigate();
  // const [menuData, setMenuData] = useState([]);
  const [isExpanded, setIsExpanded] = useState(true);
  const [menuItems, setMenuItems] = useState([]);
  const [activeLink, setActiveLink] = useState(location.pathname);
  const [dropdownState, setDropdownState] = useState({});
  const [categoryCollapseState, setCategoryCollapseState] = useState({});
  const [authorizedRoutes, setAuthorizedRoutes] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // Add search query state
  const [searchResults, setSearchResults] = useState([]); // Store search results
  const [isSearching, setIsSearching] = useState(false); // Track search state
  const [scrollTargetPath, setScrollTargetPath] = useState("");
  const [collapsedTooltip, setCollapsedTooltip] = useState(null);
  const menuItemRefs = useRef({});
  const userName = localStorage.getItem("userName") || "User";
  const userRole = localStorage.getItem("user_role") || "";
  const userInitials = userName
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
  const formattedUserRole = userRole
    .replace(/_/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

  useEffect(() => {
    if (onSidebarToggle) {
      onSidebarToggle(isExpanded);
    }
  }, [isExpanded, onSidebarToggle]);

  const handleSidebarToggle = () => {
    setIsExpanded((wasExpanded) => {
      const nextExpanded = !wasExpanded;

      if (!nextExpanded) {
        setSearchQuery("");
      }

      setCollapsedTooltip(null);

      return nextExpanded;
    });
  };

  const getCollapsedTooltipHandlers = (label) => ({
    onMouseEnter: (event) => {
      if (!isExpanded && label) {
        const rect = event.currentTarget.getBoundingClientRect();
        setCollapsedTooltip({
          label,
          top: rect.top + rect.height / 2,
        });
      }
    },
    onMouseLeave: () => setCollapsedTooltip(null),
  });

  const fetchData = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(
        `${API_URL}/api/v2/get_group_menu_items`,
        {
          headers: {
            Authorization: authKey,
          },
        }
      );

      const data = normalizeMenuData(response.data);

      console.log("sidebar menu data", data);
      if (data) {
        setMenuItems(data);

        setAuthorizedRoutes(
          data.reduce(
            (routes, category) => collectRoutes(category.menu_items, routes),
            []
          )
        );
        // localStorage.setItem("menuData", JSON.stringify(data));
      }
    } catch (error) {
      console.error("Error fetching menu items:", error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const path = window.location.pathname;

    let parentIdsToOpen = [];

    menuItems.forEach((category) => {
      const result = findParentIds(category.menu_items || [], path);
      if (result) parentIdsToOpen = result;
    });

    const newDropdownState = {};
    parentIdsToOpen.forEach((id) => {
      newDropdownState[id] = true;
    });

    setDropdownState((prev) => ({
      ...prev,
      ...newDropdownState,
    }));

    setActiveLink(path); // keep sidebar highlighting correct
  }, [menuItems]);

  const handleLinkClick = (path) => {
    setActiveLink(path);

    let parentIdsToOpen = [];

    menuItems.forEach((category) => {
      const foundParents = findParentIds(category.menu_items || [], path);
      if (foundParents) {
        parentIdsToOpen = foundParents;
      }
    });

    setDropdownState((prevState) => {
      const newDropdownState = { ...prevState };
      parentIdsToOpen.forEach((id) => {
        newDropdownState[id] = true;
      });

      return newDropdownState;
    });
  };

  const toggleDropdown = (menuItemId) => {
    setDropdownState((prevState) => ({
      ...prevState,
      [menuItemId]: !prevState[menuItemId],
    }));
  };

  const getCategoryKey = (categoryData) =>
    String(
      categoryData.category_id ||
        categoryData.id ||
        categoryData.category ||
        categoryData.name ||
        "category"
    );

  const getCategoryLabel = (categoryData) =>
    String(categoryData.category || categoryData.name || "Menu");

  const toggleCategory = (categoryData) => {
    const categoryKey = getCategoryKey(categoryData);

    setCategoryCollapseState((prevState) => ({
      ...prevState,
      [categoryKey]: !prevState[categoryKey],
    }));
  };

  const handleLogout = async () => {
    try {
      const authKey = localStorage.getItem("authKey");

      if (authKey) {
        await axios.post(
          `${API_URL}/api/logout`,
          {},
          { headers: { Authorization: authKey } }
        );
      }
    } catch (error) {
      console.error("Error during logout:", error);
    } finally {
      localStorage.removeItem("authKey");
      localStorage.removeItem("userName");
      localStorage.removeItem("currentPage");
      localStorage.removeItem("itemsPerPage");
      localStorage.removeItem("selectedStatus");
      localStorage.removeItem("selectedScheduleStatus");
      localStorage.removeItem("selectedFilter");
      localStorage.removeItem("company_id");
      localStorage.removeItem("email");
      localStorage.removeItem("menuItems");
      localStorage.removeItem("user_role");
      localStorage.removeItem("menuData");

      navigate("/login");
    }
  };

  const renderIcon = (iconName, item) => {
    const IconComponent = resolveIconComponent(iconName, item);
    return <IconComponent />;
  };

  const slugifyDepartmentName = (name = "") => {
    const slug = name
      .toLowerCase()
      .trim()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

    return slug || "department";
  };

  const getMenuItemPath = (item) => {
    if (item.department_id) {
      return `/${slugifyDepartmentName(item.name)}/${item.department_id}`;
    }

    return item.route || "";
  };

  const setMenuItemRef = (path) => (element) => {
    if (!path) {
      return;
    }

    if (element) {
      menuItemRefs.current[path] = element;
    } else {
      delete menuItemRefs.current[path];
    }
  };

  useEffect(() => {
    if (!scrollTargetPath || searchQuery) {
      return undefined;
    }

    const timer = setTimeout(() => {
      const targetElement = menuItemRefs.current[scrollTargetPath];

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        setScrollTargetPath("");
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [dropdownState, menuItems, scrollTargetPath, searchQuery]);

  useEffect(() => {
    if (searchQuery.length > 1) {
      setIsSearching(true);
      const fetchSearchResults = async () => {
        try {
          const authKey = localStorage.getItem("authKey");
          const response = await axios.get(`${API_URL}/api/search_menu_items`, {
            headers: { Authorization: authKey },
            params: { query: searchQuery },
          });
          setSearchResults(normalizeMenuItems(response.data || []));
        } catch (error) {
          console.error("Error searching menu items:", error.message);
          setSearchResults([]); // Clear search results if error occurs
        } finally {
          setIsSearching(false);
        }
      };
      fetchSearchResults();
    } else {
      setSearchResults([]); // Reset search results when input is cleared
    }
  }, [searchQuery]);

  const renderMenuItem = (item) => {
    // For department items (special case in your data)
    if (item.department_id) {
      const departmentPath = getMenuItemPath(item);

      return (
        <Link
          key={item.department_id}
          to={departmentPath}
          onClick={() => handleLinkClick(departmentPath, item.department_id)}
          className={`user-link ${activeLink === departmentPath ? "active" : ""}`}
        >
          <div
            ref={setMenuItemRef(departmentPath)}
            className="user sidebar-hover"
            data-sidebar-tooltip={item.name}
            {...getCollapsedTooltipHandlers(item.name)}
          >
            <div className="user-icon">{renderIcon(item.icon, item)}</div>
            <div className="user-font" title={item.name}>
              {item.name}
            </div>
          </div>
        </Link>
      );
    }

    // For items with direct routes and no sub-menu
    if (item.route && (!item.sub_menu || item.sub_menu.length === 0)) {
      return (
        <Link
          key={item.id}
          to={item.route}
          onClick={() => handleLinkClick(item.route)}
          className={`user-link  ${activeLink === item.route ? "active" : ""}`}
        >
          <div
            ref={setMenuItemRef(item.route)}
            className="user sidebar-hover"
            data-sidebar-tooltip={item.name}
            {...getCollapsedTooltipHandlers(item.name)}
          >
            <div className="user-icon">{renderIcon(item.icon, item)}</div>
            <div className="user-font" title={item.name}>
              {item.name}
            </div>
          </div>
        </Link>
      );
    }

    // For items with sub-menus - create a dropdown
    const hasSubMenu = Array.isArray(item.sub_menu) && item.sub_menu.length > 0;
    const isOpen = dropdownState[item.id] || false;

    return (
      <div key={item.id} className="menu-dropdown">
        <div
          className={`user sidebar-hover ${isOpen ? "active" : ""}`}
          onClick={() => toggleDropdown(item.id)}
          data-sidebar-tooltip={item.name}
          {...getCollapsedTooltipHandlers(item.name)}
        >
          {/* <div className="menu-item-content"> */}
          <div className="user-icon">
            {renderIcon(item.icon || item.category_icon, item)}
          </div>
          <div className="user-font" title={item.name}>
            {item.name}
          </div>
          {hasSubMenu && (
            <div className="expand-collapse-icon">
              {isOpen ? <IoIosArrowDown /> : <IoIosArrowForward />}
              {/* {isOpen ? <IoIosArrowBack /> : <IoIosArrowForward />} */}
            </div>
          )}
          {/* </div> */}
        </div>

        {hasSubMenu && isOpen && (
          <div className="dropdown-menu">
            {item.sub_menu.map((subItem) => renderMenuItem(subItem))}
          </div>
        )}
      </div>
    );
  };

  const renderSearchResult = (item) => {
    const itemPath = getMenuItemPath(item);
    const context = [item.category, ...(item.path || [])]
      .filter(Boolean)
      .join(" / ");

    return (
      <Link
        key={item.id || item.department_id}
        to={itemPath}
        onClick={() => {
          handleLinkClick(itemPath);
          setScrollTargetPath(itemPath);
          setSearchQuery("");
        }}
        className={`user-link sidebar-search-result-link ${
          activeLink === itemPath ? "active" : ""
        }`}
      >
        <div className="user sidebar-hover sidebar-search-result">
          <div className="user-icon">{renderIcon(item.icon, item)}</div>
          <div className="sidebar-search-result-text">
            <div className="user-font" title={item.name}>
              {item.name}
            </div>
            {context && (
              <div className="sidebar-search-result-path" title={context}>
                {context}
              </div>
            )}
          </div>
        </div>
      </Link>
    );
  };

  // --- new ---
  const findParentIds = (items, targetRoute, parents = []) => {
    for (const item of items) {
      const currentRoute = getMenuItemPath(item);

      if (currentRoute === targetRoute) {
        return parents;
      }

      if (Array.isArray(item.sub_menu) && item.sub_menu.length > 0) {
        const result = findParentIds(item.sub_menu, targetRoute, [
          ...parents,
          item.id,
        ]);
        if (result) return result;
      }
    }
    return null;
  };

  return (
    <>
      <div
        className={`product-content-container ${
          isExpanded ? "app-sidebar-expanded" : "app-sidebar-collapsed"
        }`}
      >
        <div className="sidebar-container">
            <div className="sidebar-content">
              <div className="heading-border">
                <img src="/logo23231.png" alt="Logo" className="header-logos" />
              </div>
              {isExpanded && (
                <div className="search-sidebar">
                <div
                  className="search-start"
                  style={{
                    border: "1px solid rgb(163 158 158)",
                    borderRadius: "4px",
                  }}
                >
                  <FaSearch
                    style={{
                      margin: "6px 3px",
                      color: "#B1BAD4",
                      verticalAlign: "sub",
                      fontSize: "15px",
                    }}
                  />
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{
                      border: "none",
                      outline: "none",
                      flex: 1,
                      fontSize: "16px",
                    }}
                  />
                  {searchQuery && (
                    <button
                      type="button"
                      className="search-clear-button"
                      onClick={() => setSearchQuery("")}
                      aria-label="Clear search"
                      title="Clear"
                    >
                      <IoCloseOutline />
                    </button>
                  )}
                </div>
              </div>
              )}
              <div className="sidebar-content1">
                {searchQuery.length > 2 ? (
                  searchResults.length > 0 ? (
                    <div className="sidebar-search-results">
                      {searchResults.map((item) => renderSearchResult(item))}
                    </div>
                  ) : (
                    <div className="no-results">No results found</div>
                  )
                ) : (
                  menuItems.length > 0 ? (
                  menuItems.map(
                    (categoryData) => {
                      const categoryKey = getCategoryKey(categoryData);
                      const isCategoryCollapsed =
                        categoryCollapseState[categoryKey] || false;

                      return (
                        <div
                          key={categoryKey}
                          className={`menu-category ${
                            isCategoryCollapsed
                              ? "menu-category-collapsed"
                              : "menu-category-expanded"
                          }`}
                        >
                          <button
                            type="button"
                            className="menu-category-header"
                            onClick={() => toggleCategory(categoryData)}
                            aria-expanded={!isCategoryCollapsed}
                          >
                            <span className="menu-category-title">
                              {getCategoryLabel(categoryData).toUpperCase()}
                            </span>
                            <span className="menu-category-arrow">
                              {isCategoryCollapsed ? (
                                <IoIosArrowForward />
                              ) : (
                                <IoIosArrowDown />
                              )}
                            </span>
                          </button>
                          {!isCategoryCollapsed && (
                            <div className="category-items">
                              {(categoryData.menu_items || []).map((item) =>
                                renderMenuItem(item)
                              )}
                            </div>
                          )}
                        </div>
                      );
                    }
                  )
                  ) : (
                    <div className="no-results">No menu items found</div>
                  )
                )}
              </div>
              <div className="sidebar-bottom-panel">
                <button
                  type="button"
                  className="sidebar-toggle-button"
                  onClick={handleSidebarToggle}
                  title={isExpanded ? "Collapse sidebar" : "Expand sidebar"}
                  aria-label={isExpanded ? "Collapse sidebar" : "Expand sidebar"}
                  aria-expanded={isExpanded}
                >
                  <IoIosArrowForward />
                  <span className="sidebar-toggle-label">
                    {isExpanded ? "Collapse" : "Expand"}
                  </span>
                </button>
                <div className="sidebar-user-panel">
                  <div className="sidebar-user-avatar">
                    {userInitials || "U"}
                  </div>
                  <div className="sidebar-user-meta">
                    <div className="sidebar-user-name" title={userName}>
                      {userName}
                    </div>
                    {formattedUserRole && (
                      <div
                        className="sidebar-user-role"
                        title={formattedUserRole}
                      >
                        {formattedUserRole}
                      </div>
                    )}
                  </div>
                  <button
                    type="button"
                    className="sidebar-logout-button"
                    onClick={handleLogout}
                    title="Logout"
                    aria-label="Logout"
                  >
                    <FiLogOut />
                  </button>
                </div>
              </div>
            </div>
        </div>
        {!isExpanded && collapsedTooltip && (
          <div
            className="sidebar-floating-tooltip"
            style={{ top: collapsedTooltip.top }}
          >
            {collapsedTooltip.label}
          </div>
        )}
      </div>
    </>
  );
}

export default Sidebar;
